<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!applied">
        <project-page-header ref="pageHeader" :id="projectId">
          <template v-slot:actions>
            <a-space>
              <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
            </a-space>
          </template>
        </project-page-header>
        <div class="panel-body">
          <div class="page-title">填报项目预算</div>
          <div class="panel-info-section">
            <div v-if="data.budgetCheckResult == -1">
              <a-alert class="v-mb-sm no-border" type="error">
                <div slot="message">
                  <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />提交的项目预算表已被驳回</div>
                  <div class="flex v-mt-xs">
                    <span class="text-right text-grey">审核意见：</span>
                    <span class="col text-red" v-html="$utils.convertToHtml(data.budgetCheckOpinion)"></span>
                  </div>
                </div>
              </a-alert>
            </div>
            <div class="flex items-center">
              <a-space :size="4" class="v-mb-sm">
                <a-button size="small" icon="plus" type="indigo" @click="handleNewItem('append')">添加预算分类</a-button>
              </a-space>
            </div>
            <div class="flex">
              <div class="col">
                <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :expanded-row-keys.sync="expandedTableKeys" :pagination="false" :data-source="budgets" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
                  <a-table-column title="操作" data-index="action" :width="90" align="center" fixed="left">
                    <template slot-scope="text, record, index">
                      <a-space class="icon-actions" :size="2" v-if="!record.sum">
                        <span class="icon-action" title="编辑" @click="record.editing = true" v-if="!record.editing"><a-icon type="form" /></span>
                        <span class="icon-action" title="确定" @click="record.editing = false" v-else><a-icon type="check" /></span>
                        <!-- v-if="record.taskType == '-1' || record.taskType == '0'" -->
                        <a-dropdown placement="bottomLeft">
                          <span class="icon-action" title="添加"><a-icon type="plus" /></span>
                          <a-menu slot="overlay">
                            <template v-if="record.isRoot">
                              <a-menu-item key="before" @click="handleNewItem('before', record, index)">
                                <a-icon class="text-indigo" type="border-top" />
                                向前添加费用分类
                              </a-menu-item>
                              <a-menu-item key="after" @click="handleNewItem('after', record, index)">
                                <a-icon class="text-indigo" type="border-bottom" />
                                向后添加费用分类
                              </a-menu-item>
                              <a-menu-item key="append" @click="handleNewSubItem('append', record, index)">
                                <a-icon class="text-indigo" type="border-right" />
                                添加费用明细
                              </a-menu-item>
                            </template>
                            <template v-else>
                              <a-menu-item key="before" @click="handleNewSubItem('before', record, index)">
                                <a-icon class="text-indigo" type="border-top" />
                                向前添加费用明细
                              </a-menu-item>
                              <a-menu-item key="after" @click="handleNewSubItem('after', record, index)">
                                <a-icon class="text-indigo" type="border-bottom" />
                                向后添加费用明细
                              </a-menu-item>
                            </template>
                          </a-menu>
                        </a-dropdown>
                        <span class="icon-action text-red" title="删除" @click="handleRemoveTask(record, index)"><a-icon type="delete" /></span>
                      </a-space>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="name" :ellipsis="true" :width="280" align="left" fixed="left">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      费用名称
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position flex items-center" :style="{ display: 'inline-block', width: hasChildren ? `calc(100% - ${record.isRoot ? 25 : 45}px)` : '100%' }">
                        <a-input size="small" :placeholder="record.isRoot ? '费用分类名称' : '费用明细名称'" style="width: 100%" v-model="record.name" :ref="`budgetName-${record.uid}`" v-if="record.editing" />
                        <span :class="{ 'text-bold': record.sum }" v-else>{{ record.name || '-' }}</span>
                        <a-tooltip placement="top" :title="record.isRoot ? '费用分类名称' : '费用明细名称'" v-if="!record.name || !record.name.trim()">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="year" :width="90" align="center" :ellipsis="true">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      费用年份
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <a-date-picker
                          mode="year"
                          size="small"
                          placeholder="请选择"
                          v-model="record.year"
                          :open="record.showYearPanel"
                          :ref="`year-${record.uid}`"
                          @openChange="status => onYearPanelOpen(status, record)"
                          format="YYYY"
                          value-format="YYYY"
                          @panelChange="value => onYearChange(value, record)"
                          style="width: 100%"
                          allow-clear
                          v-if="record.editing"
                        />
                        <span v-else>{{ record.year || '-' }}</span>
                        <a-tooltip placement="top" title="未设置费用年份" v-if="!record.year">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column title="单价" data-index="price" :width="120" align="right" :ellipsis="true">
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <a-input-number class="no-handler text-right" size="small" v-model="record.price" @change="e => handleInputChange(record)" :min="0" style="width: 100%" v-if="record.editing" />
                        <span v-else>{{ record.price ? $utils.thousands(record.price) : '-' }}</span>
                        <!-- <a-tooltip placement="top" title="未输入单价" v-if="!record.price">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip> -->
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column title="数量" data-index="quantity" :width="90" align="right">
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <a-input-number class="no-handler text-right" size="small" v-model="record.quantity" @change="e => handleInputChange(record)" :min="0" style="width: 100%" v-if="record.editing" />
                        <span v-else>{{ record.quantity || '-' }}</span>
                        <!-- <a-tooltip placement="top" title="未输入数量" v-if="!record.quantity">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip> -->
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column data-index="amount" :width="200" align="right">
                    <span slot="title">
                      <i class="required-mark">*</i>
                      预算金额（元）
                    </span>
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <a-input-number class="no-handler text-right" size="small" v-model="record.amount" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" :min="0" :ref="`amount-${record.uid}`" style="width: 100%" v-if="record.editing" />
                        <span v-else>{{ $utils.thousands(record.amount) || '-' }}</span>
                        <a-tooltip placement="top" title="未输入预算金额" v-if="!record.amount">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                      <span class="text-bold" v-else>{{ $utils.thousands(record.amount) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="预算备注" data-index="remark" align="left">
                    <template slot-scope="text, record" v-if="!record.isRoot">
                      <a-input size="small" v-model="record.remark" style="width: 100%" v-if="record.editing"/>
                      <span v-else>{{ record.remark }}</span>
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </div>
            <div class="flex items-center v-mt-xs" v-if="budgets.length > 0">
              <span class="col font-xs">
                提示：
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                表示项不符合要求，提交至审核时有
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                标志将无法提交。
              </span>
            </div>
            <div class="text-center v-my-lg">
              <a-space>
                <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
                <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交审核</a-button>
                <a-button icon="left" type="default" key="back" @click="$router.go(-1)">返回</a-button>
              </a-space>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的项目预算表已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`../view/basic?id=${projectId}`)">查看项目</a-button>
            <a-button key="back" @click="$router.go(-1)">返回</a-button>
          </template>
        </a-result>
      </template>
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { viewPrj } from '@/api/project/other'
import { applyBudgets, getBudgets } from '@/api/project/common'
import { createNewBudget, convertBudgetsToTableData } from '@/utils/data'
export default {
  name: 'OtherBudgetDraft',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      loading: false,
      budgets: [],
      data: {},
      expandedTableKeys: [],
      saving: false,
      applied: false,
      currentRecord: {},
      fileList: [],
    }
  },
  computed: {
    hasChildren() {
      return this.budgets.some(item => item.children && item.children.length)
    },
  },
  watch: {
    $route() {
      this.init()
    },
    budgets: {
      handler() {
        let amountTotal = 0
        this.budgets.forEach(budget => {
          if (budget.children && budget.children.length) {
            let total = undefined
            budget.children.forEach(item => {
              if (typeof item.amount === 'number') {
                total = total ? this.$utils.add(total, item.amount) : item.amount
              }
            })
            budget.amount = total
            amountTotal += total || 0
          }
        })
        let sumRecord = this.budgets.find(d => d.sum)
        if (sumRecord) {
          sumRecord.amount = amountTotal
        } else {
          if (this.budgets.length) {
            this.budgets.push({
              sum: true,
              name: '合计',
              amount: amountTotal,
              isRoot: 1,
            })
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      }
    },
    load() {
      let id = this.projectId
      viewPrj(id).then(({ data }) => {
        if (data.success) {
          this.data = data.result
        }
      })
      this.loading = true
      getBudgets(id).then(({ data }) => {
        this.loading = false
        if (data.success) {
          let records = convertBudgetsToTableData(data.result)
          this.budgets = records
          this.expandedTableKeys = records.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
    },
    onDateRangeChange(dateString, record) {
      let [startDate, endDate] = dateString
      record.startDate = startDate
      record.endDate = endDate
    },
    handleInputChange(record) {
      let { price, quantity } = record
      if (this.$utils.isNum(price) && this.$utils.isNum(quantity)) {
        record.amount = this.$utils.add(parseFloat(price) * parseFloat(quantity))
      }
    },
    handleNewItem(action, task, index) {
      // let tasks = this.tasks
      let newItem = createNewBudget()
      newItem.editing = true
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 1
      if (action == 'append') {
        let sumIndex = this.budgets.findIndex(d => d.sum)
        if (sumIndex >= 0) {
          this.budgets.splice(sumIndex, 0, newItem)
        } else {
          this.budgets.push(newItem)
        }
      } else {
        this.budgets.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleNewSubItem(action, item, index) {
      let newItem = createNewBudget()
      newItem.uid = this.$utils.uuid()
      newItem.isRoot = 0
      newItem.editing = true
      if (action == 'append') {
        newItem.puid = item.uid
        if (!item.children) {
          item.children = []
        }
        newItem.parent = item
        // newItem.professionStartDate = item.startDate
        item.children.push(newItem)
        this.budgets.splice(index, 1, { ...item })
        this.$nextTick(() => {
          this.expandedTableKeys.push(item.uid)
        })
      } else {
        let parent = this.budgets.find(d => d.uid == item.puid)
        newItem.parent = parent
        newItem.puid = parent.uid
        parent.children.splice(action == 'before' ? index : index + 1, 0, newItem)
      }
    },
    handleRemoveTask(item, index) {
      if (item.isRoot) {
        this.budgets.splice(index, 1)
        if (this.budgets.filter(d => !d.sum).length == 0) {
          this.budgets = []
        }
      } else {
        let parent = this.budgets.find(d => d.uid == item.puid)
        parent.children.splice(index, 1)
        if (parent.children.length == 0) {
          parent.children = undefined
        }
      }
    },
    onYearChange(date, record) {
      record.year = date.format('YYYY')
      record.showYearPanel = false
    },
    onYearPanelOpen(status, record) {
      record.showYearPanel = status
    },
    validBudget(item) {
      let { uid, name, isRoot, year, amount } = item
      if (!name || !name.trim()) {
        item.editing = true
        this.$message.warn('费用名称不能为空')
        this.$nextTick(() => {
          this.$refs[`budgetName-${uid}`].focus()
        })
        return false
      }
      if (!isRoot) {
        if (!year) {
          item.editing = true
          this.$message.warn('费用年度不能为空')
          this.$nextTick(() => {
            this.$refs[`year-${uid}`].focus()
          })
          return false
        }
        if (!amount) {
          item.editing = true
          this.$message.warn('预算金额不能为空')
          this.$nextTick(() => {
            this.$refs[`amount-${uid}`].focus()
          })
          return false
        }
      }
      return true
    },
    handleConfirm(nextStep) {
      this.$message.destroy()
      let budgets = this.budgets
      if (budgets.length === 0) {
        this.$message.warn('未添加预算')
        return
      }
      if (nextStep) {
        for (let index = 0; index < budgets.length; index++) {
          let item = budgets[index]
          if (!this.validBudget(item)) {
            return false
          }
          if (item.children) {
            for (let i = 0; i < item.children.length; i++) {
              if (!this.validBudget(item.children[i])) {
                return false
              }
            }
          }
        }
      }
      this.$confirm({
        title: nextStep ? '确认提交项目预算？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { projectId } = this
      let budgets = this.budgets
        .filter(d => !d.sum)
        .map(({ budgetId, name, children, amount }) => {
        let item = {
          budgetId,
          name,
          amount,
        }
        if (children && children.length) {
          item.children = children.map(d => {
            return {
              budgetId: d.budgetId,
              budgetPid: d.budgetPid,
              name: d.name,
              year: d.year,
              price: d.price,
              quantity: d.quantity,
              amount: d.amount,
              remark: d.remark,
            }
          })
        }
        return item
      })
      let params = {
        projectId,
        budgets,
        nextStep,
      }
      this.saving = true
      applyBudgets(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.applied = true
            } else {
              this.$message.success('操作成功')
              this.$router.push(`../view/finance?id=${projectId}`)
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
  },
  created() {
    this.init()
  },
}
</script>
